import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import Documentation from 'Containers/Settings/Documentation'
import Document from 'Containers/Settings/Documentation/Document'
import LegalDocumentationTable from 'Containers/Settings/LegalDocumentation/LegalDocumentationTable'
import LegalDocumentationCreate from 'Containers/Settings/LegalDocumentation/LegalDocumentationCreate'
import LegalDocumentationEdit from 'Containers/Settings/LegalDocumentation/LegalDocumentationEdit'
import NetPromoterScore from 'Containers/Settings/NetPromoterScore/NetPromoterScore'
import InvoiceExport from 'Containers/Settings/InvoiceExport'
import Settings from 'Containers/Settings'
import { AdminRoute, CityManagerRoute } from 'Config/Routing/auth'

import { PATHS } from 'Config/Routing/paths'
import TagsManagementCreate from 'Containers/Settings/TagsManagement/TagsManagementCreate'
import TagsManagementEdit from 'Containers/Settings/TagsManagement/TagsManagementEdit'
import TagsManagementTable from 'Containers/Settings/TagsManagement'
import { DOCUMENT_FORM } from '../../Containers/Settings/Documentation/constants'
import UrlShortener from '../../Containers/Settings/UrlShortener/UrlShortener'
import XeroConnection from '../../Containers/Settings/XeroConnection'
import AddPayment from '../../Containers/Settings/AddPayment'

class SettingsRouter extends Component {
  render() {
    return (
      <Switch>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.documentCreate
          }`}
        >
          <AdminRoute>
            <Document mode={DOCUMENT_FORM.CREATE} />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.documentEdit
          }`}
        >
          <AdminRoute>
            <Document mode={DOCUMENT_FORM.EDIT} />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.documentation
          }`}
        >
          <AdminRoute>
            <Documentation />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.invoiceExport
          }`}
        >
          <AdminRoute>
            <InvoiceExport />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.legalDocumentationCreate
          }`}
        >
          <AdminRoute>
            <LegalDocumentationCreate />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.legalDocumentationEdit
          }`}
        >
          <AdminRoute>
            <LegalDocumentationEdit />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.legalDocumentation
          }`}
        >
          <AdminRoute>
            <LegalDocumentationTable />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagementCreate
          }`}
        >
          <AdminRoute>
            <TagsManagementCreate />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagementEdit
          }`}
        >
          <AdminRoute>
            <TagsManagementEdit />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagement
          }`}
        >
          <AdminRoute>
            <TagsManagementTable />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.npsScore
          }`}
        >
          <AdminRoute>
            <NetPromoterScore />
          </AdminRoute>
        </Route>
        <Route exact path={this.props.match.url}>
          <CityManagerRoute>
            <Settings />
          </CityManagerRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.urlShortener
          }`}
        >
          <AdminRoute>
            <UrlShortener />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.xeroConnection
          }`}
        >
          <AdminRoute>
            <XeroConnection />
          </AdminRoute>
        </Route>
        <Route
          path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.addPayment
          }`}
        >
          <AdminRoute>
            <AddPayment />
          </AdminRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(SettingsRouter)
